module.exports = __webpack_public_path__ + "static/media/authentication-bg.c6b58f2b.jpg";